import LinkGuide from '@/components/organisms/LinkGuide';
import MarketRegisterContainer from '@/containers/market/MarketRegisterContainer';
import MARKET_GUIDE_DATA, { type GuideImage, type GuideLink } from '@/contents/marketGuide';
import { useLocation, useNavigate } from 'react-router-dom';

import { CPLAT_API_ROUTES, useFetch } from '@/api';
import DeprecatedMarketInfoCard from '@/components/organisms/DeprecatedMarketInfoCard';
import { DEPRECATED_MARKET } from '@/contents/deprecatedMarket';
import { useAppSelector } from '@/redux/store';
import { ROUTES } from '@/routes';
import { ChevronLeft } from 'lucide-react';
import ErrorPage from './ErrorPage';
import ExternalRegisterMarketPage from './ExternalRegisterMarketPage';
import MarketGuideImageCard from '@/components/organisms/MarketGuideImageCard';

const MarketRegisterPage = () => {
  const user = useAppSelector((state) => state.user);
  const navigate = useNavigate();
  const location = useLocation();
  // TODO 추후 적절한 loading ui 가 들어오면 suspenseFetch 로 수정
  const { data: res, isLoading } = useFetch<CplatApiResponse<MarketInfo[]>>(
    CPLAT_API_ROUTES.getMarketModel,
    {
      method: 'POST',
      params: { cplatToken: user.CplatToken },
    },
  );

  if (!res || isLoading) return null;

  const { data: list } = res;

  const marketPathName = location.pathname.split('/').at(-1);

  const data = list.find((item) => item.MarketNameEnglish === marketPathName) as MarketInfo;
  const { MarketName, MarketNameEnglish, MarketTextboxOptionalList, MarketAuthCheckOptionalList } =
    data;

  // 외부에서 마켓 연동을 해야 하는 마켓 분기 처리 현재 (스마트스토어, 샵바이, 카페 24)
  const externalRegisterMarketList = ['smartstore', 'shopby', 'cafe24', 'imweb'];
  if (externalRegisterMarketList.includes(MarketNameEnglish))
    return (
      <ExternalRegisterMarketPage marketName={MarketName} marketNameEnglish={MarketNameEnglish} />
    );

  const marketGuide = MARKET_GUIDE_DATA[MarketNameEnglish] ?? [];

  // if (!marketGuide) return <ErrorPage isError className="w-full" />;

  const imgGuide = marketGuide?.filter((guide) => guide?.type === 'guideImg') as GuideImage[];
  const linkGuide = marketGuide?.filter((guide) => guide?.type === 'linkGuide') as GuideLink[];

  const isEmptyGuideImg = imgGuide.length <= 0;

  const handleBack = () => {
    navigate(ROUTES.market);
  };

  // 기존 esm, 지마켓, 옥션은 deprecated 되었음 new가 붙는 name이 연동가능한 마켓(gmarket-new)
  const isDeprecated = DEPRECATED_MARKET.includes(marketPathName || '');

  return (
    <div className=" flex h-full w-full  flex-1 flex-col gap-[16px] bg-gr-50 ">
      <div className="mx-auto flex h-full w-full max-w-full flex-1 flex-col gap-[16px] p-[40px] px-[60px]">
        {isDeprecated ? (
          <div className="mt-[12px] flex w-full flex-col justify-center">
            <div className="flex w-full flex-col">
              <div className=" w-full flex-shrink-0 ">
                <button
                  onClick={handleBack}
                  className="mb-[24px] flex w-full gap-[12px]  text-gr-900 Title2S24"
                >
                  <ChevronLeft className="h-8 w-8" />
                  뒤로가기
                </button>
                <div className="flex w-full">
                  <DeprecatedMarketInfoCard
                    marketList={list}
                    selectedMarketName={marketPathName || ''}
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className=" flex h-fit w-full flex-wrap gap-[18px] pb-[40px]">
            <div className="flex w-full items-start justify-center gap-10">
              <div className="sticky top-[40px]">
                <button
                  onClick={handleBack}
                  className="mb-[24px] flex w-full gap-[12px]  text-gr-900 Title2S24"
                >
                  <ChevronLeft className="h-8 w-8" />
                  뒤로가기
                </button>
                <MarketRegisterContainer
                  marketName={MarketName}
                  marketNameEnglish={MarketNameEnglish}
                  marketTextboxOptionalList={MarketTextboxOptionalList}
                  marketAuthCheckOptionalList={MarketAuthCheckOptionalList}
                />
              </div>
              {(imgGuide.length > 0 || linkGuide.length > 0) && (
                <div className="relative w-full  flex-1">
                  <div className="sticky top-0 z-20 h-[56px] bg-gr-50" />
                  <div className=" space-y-[30px]">
                    {linkGuide?.map((guide) => (
                      <LinkGuide guide={guide} key={guide.contents.linkUrl} />
                    ))}
                    {isEmptyGuideImg ? null : (
                      <>
                        {imgGuide.map(({ guideImageUrl }) => {
                          return (
                            <MarketGuideImageCard
                              key={guideImageUrl}
                              guideImageUrl={guideImageUrl}
                              marketName={MarketName}
                            />
                          );
                        })}
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MarketRegisterPage;
